import { createRouter, createRootRoute, createRoute } from "@tanstack/react-router";

// Import components
import { RootLayout } from "./routes/__root";
import { LandingPage } from "./pages/landing/LandingPage";
import { LoginPage } from "./pages/auth/login/LoginPage";
import { SignupPage } from "./pages/auth/signup/SignupPage";
import { ForgotPasswordPage } from "./pages/auth/forgot-password/ForgotPasswordPage";
import { ResetPasswordPage } from "./pages/auth/reset-password/ResetPasswordPage";
import { ProfilePage } from "./pages/profile/ProfilePage";
import { DashboardPage } from "./pages/dashboard/DashboardPage";
import { SupportPage } from "./pages/support/SupportPage";

/**
 * Route Tree
 *
 * Define the application's route hierarchy using TanStack Router.
 */

// Root route with layout
const rootRoute = createRootRoute({
  component: RootLayout,
});

// Index/Landing page
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: LandingPage,
});

// Auth routes
const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginPage,
});

const signupRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/signup",
  component: SignupPage,
});

const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/forgot-password",
  component: ForgotPasswordPage,
});

const resetPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/reset-password",
  component: ResetPasswordPage,
});

// Protected routes
const profileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/profile",
  component: ProfilePage,
});

const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/dashboard",
  component: DashboardPage,
});

const supportRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/support",
  component: SupportPage,
});

// Build the route tree
const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  signupRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
  profileRoute,
  dashboardRoute,
  supportRoute,
]);

/**
 * Router Instance
 *
 * The main router for the application.
 * Export this to use in App.tsx with RouterProvider.
 */
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
});

// Type declaration for TypeScript
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export default router;
